import { Component } from '@angular/core';
import { Router } from '@angular/router'
import { SessionService, SessionData } from '../common/session.service';
import { ApiClient } from '../common/api-client.service';

class NewUserModel {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  password_confirmation: string;
}

@Component({
  templateUrl: './register.component.html'
})
export class RegisterComponent {
  user = new NewUserModel();

  constructor(
    private session: SessionService,
    private apiClient: ApiClient,
    private router: Router,
  ) {}

  register() {
    this.apiClient.post<SessionData>('/api/v1/user', this.user).toPromise().then(sess => {
      this.session.start(sess);
      this.router.navigateByUrl('/');
    }, res => {
      // TODO handle errors
      alert(res.error.errors);
    });
  }
}



// WEBPACK FOOTER //
// /srv/src/app/registration/register.component.ts